import { render } from "./CoachDetail.vue?vue&type=template&id=778e197f"
import script from "./CoachDetail.vue?vue&type=script&lang=js"
export * from "./CoachDetail.vue?vue&type=script&lang=js"

import exportComponent from "D:\\vue\\Vue_Lessons\\coachApps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__